import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import { Plus } from "mdi-material-ui";
import React from "react";

import AdPresetForm from "./Form";

AddAdPresetDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Create Ad Group",
  };
};

export default function AddAdPresetDialog({ orgId, onSubmit, onClose }) {
  const addAdPreset = useActionFragment("addAdPreset", "adPreset { id }");

  return (
    <FormDialog
      header="Create Ad Group"
      onClose={onClose}
      onSubmit={async (formData) => {
        const result = await addAdPreset({ input: formData });
        await onSubmit?.(result.addAdPreset.adPreset);
      }}
    >
      <AdPresetForm
        adPresets={[
          {
            org: orgId && { id: orgId, __typename: "Org" },
          },
        ]}
      />
    </FormDialog>
  );
}
